import React from "react";
import Head from "./Head";
import BarGraph from "../../../../../components/common/BarGraph";
import "../fileChart.scss";
import NoChartData from "../../../../../components/common/NoChartData";
import ChartValueCount from './ChartValueCount';

const FileChart = (
	{
		barColor,
		className = 'bar-graph',
		headingLabel = 'file-chart',
		data = [],
		handleClick,
		loading,
		options,
		totalPackets1
	}
) =>

{

	return (
		<>
			<div className={`file-chart d-flex flex-column ${className}`}>
				<Head headingLabel={headingLabel} _handleClick={handleClick} options={options} />
				<div className="inner">
					<div className="inner-bar-graph position-relative">
						{/* {data.length === 0 && !loading ? <NoChartData /> :
							<BarGraph barColor={barColor} data={data} loading={loading} />} */}
							{data.length === 0 && !loading ? <NoChartData /> : data.length === 1 && !loading?  <ChartValueCount data={data}  />: <BarGraph barColor={barColor} data={data} loading={loading} />}
							
					</div>
				</div>
				{/* <ChartValueCount /> */}
			</div>
		</>
	);
}
export default FileChart;
